const styles = {
    textField:{
      input: {
        fontSize:14,
        fontFamily: 'Quicksand'
      },
      minWidth: '300px',
      "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: "#28a5ad"
      },
      "& .MuiInputLabel-outlined.Mui-focused": {
        color: "#28a5ad"
      }
    },
    title:{
      fontSize: '20px',
      lineHeight: '23.44px',    
      fontFamily: 'Quicksand',
      fontWeight: '500',
      color: '#18428F'
    },
    selectField:{
      fontSize: 12,
      fontFamily: 'Quicksand',
      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: '#28a5ad',
      }
    },
    label:{
      fontFamily: 'Quicksand',
      fontStyle: 'normal',
      fontWeight: '300',
      fontSize: '16px',
      lineHeight: '20px',
      textTransform: 'none',
      padding: '0 16px'
    },
    saveButton:{
      fontFamily: 'Quicksand',
      fontStyle: 'normal',
      fontWeight: '500',
      fontSize: '20px',
      lineHeight: '25px',
      background: '#EBEEFF',
      borderRadius: '8px',
      padding: '8px 24px',
      color: '#18428F',
      boxShadow: 'none',
      textTransform: 'none',
      border: 'none'
    },
    cancelButton:{
      fontFamily: 'Quicksand',
      fontStyle: 'normal',
      fontWeight: '500',
      fontSize: '20px',
      lineHeight: '25px',
      background: '#EBEEFF',
      borderRadius: '8px',
      padding: '8px 24px',
      color: '#18428F',
      boxShadow: 'none',
      textTransform: 'none',
      border: 'none'
    }
  };
  
  export default styles;
  